var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-6" }, [
        _c("div", { staticClass: "mb-2" }, [
          _c("label", { attrs: { for: "rfname" } }, [
            _c("small", [_vm._v(_vm._s(_vm._f("translate")("First name")))]),
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.first_name,
                expression: "first_name",
              },
            ],
            staticClass: "form-control",
            class: { "is-invalid": "name" in _vm.errors },
            attrs: { id: "rfname", type: "text" },
            domProps: { value: _vm.first_name },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.first_name = $event.target.value
              },
            },
          }),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-6" }, [
        _c("div", { staticClass: "mb-2" }, [
          _c("label", { attrs: { for: "rflastname" } }, [
            _c("small", [_vm._v(_vm._s(_vm._f("translate")("Last name")))]),
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.last_name,
                expression: "last_name",
              },
            ],
            staticClass: "form-control",
            class: { "is-invalid": "last_name" in _vm.errors },
            attrs: { id: "rflastname", type: "text" },
            domProps: { value: _vm.last_name },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.last_name = $event.target.value
              },
            },
          }),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "mb-2" }, [
      _c("label", { attrs: { for: "remail" } }, [
        _c("small", [_vm._v(_vm._s(_vm._f("translate")("Email")))]),
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.email,
            expression: "email",
          },
        ],
        staticClass: "form-control",
        class: { "is-invalid": "email" in _vm.errors },
        attrs: { id: "remail", type: "email" },
        domProps: { value: _vm.email },
        on: {
          blur: _vm.checkEmailTypo,
          input: function ($event) {
            if ($event.target.composing) return
            _vm.email = $event.target.value
          },
        },
      }),
      _vm._v(" "),
      _vm.emailSuggestion
        ? _c("div", { staticClass: "form-text" }, [
            _c("small", [
              _vm._v(
                "\n        " +
                  _vm._s(_vm._f("translate")("Did you mean")) +
                  "\n        "
              ),
              _c(
                "a",
                {
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.applySuggestion.apply(null, arguments)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.emailSuggestion))]
              ),
              _vm._v("?\n      "),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "invalid-feedback" }, [
        _c("small", [
          _vm._v(
            "\n        " +
              _vm._s(_vm._f("translate")("Already have an account?")) +
              "\n        "
          ),
          _c(
            "a",
            {
              attrs: { href: "#" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.openModal.apply(null, arguments)
                },
              },
            },
            [
              _vm._v(
                "\n          " +
                  _vm._s(_vm._f("translate")("Sign in")) +
                  "\n        "
              ),
            ]
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    !_vm.no_checkout_password
      ? _c("div", { staticClass: "mb-2" }, [
          _c("label", { attrs: { for: "rpassword" } }, [
            _c("small", [_vm._v(_vm._s(_vm._f("translate")("Password")))]),
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.password,
                expression: "password",
              },
            ],
            staticClass: "form-control",
            class: { "is-invalid": "password" in _vm.errors },
            attrs: { if: "rpassword", type: "password" },
            domProps: { value: _vm.password },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.password = $event.target.value
              },
            },
          }),
          _vm._v(" "),
          _c("small", [_c("InputErrors", { attrs: { name: "password" } })], 1),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }